<template>
  <div class="baseSetting-main">
    <div class="title">
      <span class="parent">系统设置 / </span>
      <span>个性化设置</span>
    </div>
    <div class="container">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="自定义设置中心" name="first">
          <div class="setting-prepare">
            <div class="setting-title"><b></b>备课中心</div>
            <div class="setting-content">
              <span>课程说明</span>
              <el-switch v-model="prepareShow" inactive-text="隐藏" active-text="显示" @change="updateSchoolPrepareContentAuth">
              </el-switch>
              <div class="setting-tip">
                开启后，可在备课中心查看课程说明！
              </div>
            </div>
          </div>
          <div class="setting-ojRank">
            <div class="setting-title"><b></b>信奥专区</div>
            <div class="setting-content">
              <span>全国排名</span>
              <el-switch v-model="ojRankShow" inactive-text="隐藏" active-text="显示" @change="updateSchoolOjRankTotalAuth">
              </el-switch>
            </div>
            <div class="setting-tip">
              开启后，信奥专区将展示全国排名信息！
            </div>
          </div>
          <div class="setting-passwordHint">
            <div class="setting-title">学生端密码强度提示</div>
            <div class="setting-content">
              <span>密码强度提示</span>
              <el-switch v-model="passwordStrengthHintShow" inactive-text="隐藏" active-text="显示" @change="postEduUpdateStuPwdRemind">
              </el-switch>
            </div>
            <div class="setting-tip">
              开启后，学生若密码过于简单，系统将提示您增强密码强度！
            </div>
          </div>
          <div class="setting-passwordHint">
            <div class="setting-title">学生端家校通</div>
            <div class="setting-content">
              <span>家校通</span>
              <el-checkbox v-model="homeSchoolCommunication.publicAccountQrcode" @change="updateWechatQr">公众号二维码</el-checkbox>
              <el-checkbox v-model="homeSchoolCommunication.miniprogramQrcode" @change="updateWechatMiniQr">小程序二维码</el-checkbox>
            </div>
            <div class="setting-tip">
              勾选相应选项后，学生端-家校通展示对应的二维码。
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="星币设置" name="second">
          <div class="setting-prepare">
            <div class="setting-title"><b></b>星币设置</div>
            <div class="setting-content">
              <span class="setting-label">星币管理</span>
              <el-radio v-model="starCoinManageShow" :label="true" @input="methodChangeVersion">开启星币管理</el-radio>
              <el-radio v-model="starCoinManageShow" :label="false" @input="methodChangeVersion">关闭星币管理</el-radio>
              <!-- <div class="setting-tip right">
                <i class="el-icon-warning"></i> 开启后，缺勤的学生扣除课时！
              </div> -->
            </div>
          </div>
          <!-- <rulesSetting :campusData="campusData" v-if="activeName === 'third'" /> -->
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
// component
// import rulesSetting from '../starCoinManagement/rulesSetting'
// api
import {
  api_updateSchoolPrepareContentAuth, // 更新备课中心课程说明
  api_updateSchoolOjRankTotalAuth, // 更新信奥专区学校排名方式
} from '@/api/educational'
import {
  api_eduTchGetStuPwdRemind, // 获取学生端密码强度提示
  api_eduUpdateStuPwdRemind, // 修改学生端密码强度提示
  api_updateSchoolPointAuth, // 星币开关
  api_eduUpdateWechatQr, // 学生端家校通-更新公众号二维码示设置
  api_eduUpdateWechatMiniQr, // 学生端家校通-更新小程序二维码显示设置
} from '@/api/javaApi'

export default {
  name: 'basePersonalizedSettingVue',
  components: {
    // rulesSetting
  },
  data() {
    return {
      activeName: 'first',
      campusData: this.$store.state.user.selected_schools, // 所属校区信息列表
      prepareShow: false,
      ojRankShow: false,
      passwordStrengthHintShow: false,
      homeSchoolCommunication: {
        publicAccountQrcode: false,
        miniprogramQrcode: false,
      },
      starCoinManageShow: true, // 星币管理开启
    }
  },
  created() {
    this.getEduTchGetStuPwdRemind();
    this.prepareShow = this.$store.state.user.schoolInfo.prepareContentAuth
    this.ojRankShow = this.$store.state.user.schoolInfo.ojRankTotalAuth
    this.starCoinManageShow = this.$store.state.user.schoolInfo.pointAuth
    this.homeSchoolCommunication.publicAccountQrcode = this.$store.state.user.schoolInfo.wechatQr;
    this.homeSchoolCommunication.miniprogramQrcode = this.$store.state.user.schoolInfo.wechatMiniQr;
  },
  methods: {
    methodChangeVersion(val) {
      console.log(val)
      this.updateSchoolPointAuth()
    },
    updateSchoolPointAuth() {
      // const permisionList = this.$store.state.user.permisionList
      api_updateSchoolPointAuth({ state: this.starCoinManageShow }).then(
        (res) => {
          console.log(res)
          // 设置开启关闭星币管理
          this.$store.dispatch('freshUserData')
          this.$message.success(
            this.starCoinManageShow
              ? '星币管理已开启'
              : '星币管理已关闭'
          )
        }
      )
    },
    getEduTchGetStuPwdRemind() {
      api_eduTchGetStuPwdRemind().then(res => {
        console.log(res)
        this.passwordStrengthHintShow = res;
      })
    },
    postEduUpdateStuPwdRemind() {
      api_eduUpdateStuPwdRemind({
        state: this.passwordStrengthHintShow
      }).then(res => {
        console.log(res);
        this.$message.success('更改成功')
        this.getEduTchGetStuPwdRemind();
      })
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    updateSchoolPrepareContentAuth() {
      api_updateSchoolPrepareContentAuth({
        prepare_content_auth: this.prepareShow,
      }).then((res) => {
        console.log(res)
        if (res.is_update) {
          this.$store.state.user.schoolInfo.prepareContentAuth = this.prepareShow
          this.$message.success('更改成功')
          this.$store.dispatch('freshUserData')
        }
      })
    },
    updateSchoolOjRankTotalAuth() {
      api_updateSchoolOjRankTotalAuth({
        oj_rank_total_auth: this.ojRankShow,
      }).then((res) => {
        console.log(res)
        if (res.is_update) {
          this.$store.state.user.schoolInfo.ojRankTotalAuth = this.ojRankShow
          this.$message.success('更改成功')
          this.$store.dispatch('freshUserData')
        }
      })
    },
    updateWechatQr() {
      api_eduUpdateWechatQr({
        state: this.homeSchoolCommunication.publicAccountQrcode
      }).then((res) => {
        console.log(res)
        this.$store.state.user.schoolInfo.wechatQr = this.homeSchoolCommunication.publicAccountQrcode
        this.$message.success('更改成功')
        this.$store.dispatch('freshUserData')
      })
    },
    updateWechatMiniQr() {
      api_eduUpdateWechatMiniQr({
        state: this.homeSchoolCommunication.miniprogramQrcode
      }).then((res) => {
        console.log(res)
        this.$store.state.user.schoolInfo.wechatMiniQr = this.homeSchoolCommunication.miniprogramQrcode
        this.$message.success('更改成功')
        this.$store.dispatch('freshUserData')
      })
    },
  },
}
</script>
<style scoped lang="scss">
.baseSetting-main {
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100% + 60px);
  padding: 10px;
  .title {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    height: 60px;
    padding-left: 20px;
    margin-bottom: 10px;
    background: #ffffff;
    font-size: 14px;
    box-shadow: 0px 0px 4px 0px #f0f4f5;
    border-radius: 5px;
    border: 1px solid #f4f5f9;
    span {
      vertical-align: middle;
      padding-top: 3px;
      &.parent {
        padding-top: 0;
        margin-right: 10px;
        font-size: 16px;
      }
    }
  }
  .container {
    flex: 1;
    // background-color: #fff;
    .el-tabs {
      padding: 10px 20px 20px;
      background-color: #fff;
      border-radius: 5px;
      margin-bottom: 20px;
    }
    .setting-prepare,
    .setting-ojRank,
    .setting-passwordHint {
      width: 100%;
      border: 1px solid #eee;
      border-radius: 5px;
      padding: 15px 15px;
      margin: 10px 0 20px;
      .setting-title {
        display: flex;
        align-items: center;
        padding-bottom: 20px;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        b {
          width: 3px;
          height: 14px;
          margin-right: 5px;
          background-color: #1978ff;
          border-radius: 30px;
        }
      }
      .setting-content {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 10px;
        span {
          padding-right: 20px;
          font-size: 14px;
          &.setting-label {
            width: 155px;
          }
        }
        .el-switch /deep/ {
          .el-switch__label {
            span {
              font-size: 12px;
            }
          }
        }
      }
      .setting-tip {
        width: 100%;
        padding-top: 20px;
        color: #999;
        font-size: 12px;
        &.right {
          width: auto;
          padding-top: 0;
          margin-left: 20px;
        }
      }
    }
  }
}
</style>
